import { useQuery } from "@tanstack/react-query";
import { url_270 } from "../../../../../../custom_utilities/api_services";
import axios from "axios";
import useAuthUtils from "../../../../../../hooks/auth/useAuthUtils";

export const useGetFeeDetails = () => {
  const { headers } = useAuthUtils();

  const fetchFeeDetails = async () => {
    try {
      const response = await axios.get(url_270, { headers });
      console.log("response", response);
      return response?.data;
    } catch (err) {
      return {};
    }
  };

  return useQuery({
    queryKey: ["fee-details"],
    queryFn: fetchFeeDetails,
  });
};
